import { useQuery } from '@tanstack/react-query'
import { fetchHealthDashboard, fetchOpsHealth } from './api.js'

/** 5-minute `staleTime`, matching the backend's own aggregate cache tier for this endpoint (tech stack §2). */
export function useHealthDashboard() {
  return useQuery({
    queryKey: ['health-dashboard'],
    queryFn: fetchHealthDashboard,
    staleTime: 5 * 60_000,
  })
}

/**
 * OPS-013. Refetched every minute while the screen is open: the box's own
 * healthcheck writes every 5 minutes, so a left-open tab should notice a new
 * problem (or a stopped heartbeat) without a manual reload.
 */
export function useOpsHealth() {
  return useQuery({
    queryKey: ['ops-health'],
    queryFn: fetchOpsHealth,
    staleTime: 30_000,
    refetchInterval: 60_000,
  })
}
